import React, { useState, useRef, useEffect } from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link, useHistory } from "react-router-dom";
// import apiAuth from "../../helpers/ApiAuth";
import API from "../../helpers/API";
import NotificationManager from "../../components/Common/NotificationManager";
import NewHeader from "../../Layouts/NewHeader";
import NewFooter from "../../Layouts/NewFooter";
import FormPreview from "./FormPreview";
import { trimStart, toLower } from "lodash";
import BreadCrumb from "../../components/Common/BreadCrumb";

const Main = () => {
  const [rechargeOptions, setRechargeOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFormPage, setIsFormPage] = useState();
  const [consumerData, setConsumerData] = useState([]);

  const history = useHistory();

  console.log("local storage", localStorage.getItem("authUser"));

  const handleSecureMeterApi = () => {
    API.get(`/api/Consumer/SecureMetersService`)
      .then((res) => {
        console.log("responseee", res);
        const { data } = res;
        if (data === "Yes I'm OK.") {
          setIsFormPage(true);
        } else {
          setIsFormPage(false);
          NotificationManager.error(
            "Consumer details",
            "Secure meter service error",
            3000,
            null,
            null,
            ""
          );
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
        setIsFormPage(false);
        NotificationManager.error(
          "Consumer details",
          "Secure meter service error",
          3000,
          null,
          null,
          ""
        );
      });
  };

  const handleGenusApi = (consumerno) => {
    API.get(`api/Consumer/GenusService/${consumerno}`)
      .then((res) => {
        console.log("responseee", res);

        const { data } = res;

        if (data?.includes("does not exist")) {
          setIsFormPage(false);
          NotificationManager.error(
            "Consumer details",
            "Consumer No does not exist",
            3000,
            null,
            null,
            ""
          );
        } else {
          const detailsString = data?.split("@");
          console.log("details string", detailsString);
          const consumerNo = detailsString[0];
          const meterNo = detailsString[1];
          setIsFormPage(true);
        }
        // setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
        setIsFormPage(false);
        NotificationManager.error(
          "Consumer details",
          "Genus service error",
          3000,
          null,
          null,
          ""
        );
      });
  };

  const handleBackButton = () => {
    // localStorage.setItem("isFormPage", false);
    setIsFormPage(false);
    setLoading(false);
  };

  const handleConsumerSubmit = (values) => {
    const consumerId = trimStart(values?.consumer_id?.trim(), "0");
    setLoading(true);

    API.get(`/api/Consumer/validate/${consumerId}`)
      .then((res) => {
        console.log("responseee", res);
        const { data } = res;

        const rechargeOpts = data?.rechargeAmounts?.map((item) => {
          return {
            label: item,
            value: item,
          };
        });

        if (data?.division === "Kohima") {
          handleGenusApi(data?.consumerno);
        } else {
          handleSecureMeterApi();
        }

        setConsumerData(data);
        setRechargeOptions(rechargeOpts);

        // localStorage.setItem("consumer_no", data?.consumerno);
        // localStorage.setItem("isFormPage", true);
      })
      .catch((err) => {
        console.log("error", err?.response);
        setLoading(false);
        NotificationManager.error(
          "Consumer details",
          "Invalid Consumer number",
          3000,
          null,
          null,
          ""
        );
      });
  };

  // console.log("loadinggggg", loading);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          overflowX: "hidden",
        }}
      >
        <NewHeader />
        {/* <div className="container" style={{ flex: "1" }}> */}
        <div
          className="mt-4 p-5"
          style={{
            background:
              "linear-gradient(180deg, rgba(23, 0, 0, 0.80) 28.15%, rgba(0, 11, 5, 0.80) 99.2%)",
            backdropFilter: "blur(30px)",
          }}
        >
          <h5 style={{ color: "#FFF", fontSize: "25px", fontWeight: "700" }}>
            Prepaid Electricity Recharge
          </h5>
          {localStorage.getItem("username") && <BreadCrumb />}
        </div>

        <div className="container mx-1" style={{ flex: "1" }}>
          <Grid container>
            <Grid item lg={9} xs={12}>
              <div
                className="card px-5 py-5 my-3 mx-2 m-auto shadow-lg position-relative"
                style={{
                  top: "-45px",
                  borderRadius: "10px",
                  margin: "auto !important",
                }}
              >
                {isFormPage ? (
                  <FormPreview
                    handleBackButton={handleBackButton}
                    consumerData={consumerData}
                    rechargeOptions={rechargeOptions}
                  />
                ) : (
                  <div className="d-flex justify-content-between flex-wrap">
                    <Formik
                      initialValues={{
                        consumer_id: "",
                      }}
                      validationSchema={Yup.object({
                        consumer_id: Yup.string().required("Required!"),
                      })}
                      onSubmit={handleConsumerSubmit}
                    >
                      {({ values, errors, touched, setFieldValue }) => (
                        <Form className="av-tooltip tooltip-label-bottom">
                          <Grid>
                            {/*  Consumer Number */}
                            <Grid container spacing={2}>
                              <Grid item lg={12} xs={12} className=" mt-2 mb-2">
                                <div className="mb-3">
                                  <label
                                    htmlFor="consumer_id"
                                    className="form-label"
                                    style={{
                                      color: "#9e9e9e",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Please enter your Consumer No or Meter No
                                    <span className="text-danger">*</span>
                                  </label>
                                  <Field
                                    className="form-control"
                                    name="consumer_id"
                                    placeholder="Consumer Number"
                                    style={{
                                      borderRadius: "0",
                                      border: "none",
                                      borderBottom: "1px solid #9e9e9e",
                                    }}
                                    onMouseOver={(e) =>
                                      (e.target.style.borderColor = "#26a69a")
                                    }
                                    onMouseOut={(e) =>
                                      (e.target.style.borderColor = "#9e9e9e")
                                    }
                                    onClick={(e) =>
                                      (e.target.style.borderColor = "#26a69a")
                                    }
                                    autocomplete="off"
                                  />
                                  <ErrorMessage
                                    name="consumer_id"
                                    render={(msg) => (
                                      <div className="text-danger">{msg}</div>
                                    )}
                                  />
                                </div>
                                <div className="mb-3">
                                  {loading ? (
                                    <div
                                      className="spinner-border"
                                      role="status"
                                      style={{ color: "rgba(40, 40, 40, 0.8)" }}
                                    >
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="mt-4 mb-3">
                                      <Button
                                        className="btn my-2 w-100"
                                        type="submit"
                                        style={{
                                          color: "white",
                                          fontWeight: 500,
                                          fontSize: "16px",
                                          background:
                                            "linear-gradient(90deg, #433232 5.56%, #383735 95.49%)",
                                          borderRadius: "5px",
                                          boxShadow:
                                            "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        Next
                                      </Button>
                                    </div>
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Form>
                      )}
                    </Formik>
                    <div>
                      <Link to="/view_history">
                        <span style={{ cursor: "pointer", color: "#C90000" }}>
                          View History
                        </span>
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </div>
        {/* </div> */}
        <NewFooter />
      </div>
    </>
  );
};

export default Main;
